module Bookhus {

    export enum CalendarStatusDisplayMode {        
        Default = 0,
        TipOnly = 1,
        FullRange = 2
    }

    export enum PeriodType {
        Event = -20,
        Channel = -9,
        RelationshipMatrixLock = -8,
        AvailabilityLock = -7,
        Restricted = -6,
        Available = -5,
        PriceMissing = -2,
        Draw = -1,
        Wish = 0,
        Booking = 1,
        Locked = 2
    }

    export class CalendarDaydataService implements ICalendarDaydataService {
        private showPeriodseperation: boolean;
        private calendarStatusDisplayMode: CalendarStatusDisplayMode;
        private currentUsersId: number;
        private mediumBookingborder: number;
        private minBookingborder: number;
        public bookings: IBooking[];
        mindate: Date;
        houseOpenUntill: Date;
        sysMaxDateGælderIkkeForLodtrækninger: boolean;
        houseId: number;

        separateTime: number;

        constructor(minBookingborder: number, mediumBookingborder: number, currentUsersId: number, showPeriodseperation: boolean, separateTime: number = 12, calendarStatusDisplayMode: CalendarStatusDisplayMode = CalendarStatusDisplayMode.Default) {
            this.showPeriodseperation = showPeriodseperation;
            this.calendarStatusDisplayMode = calendarStatusDisplayMode;
            this.currentUsersId = currentUsersId;
            this.mediumBookingborder = mediumBookingborder;
            this.minBookingborder = minBookingborder;
            this.separateTime = separateTime < 0 || separateTime > 24 ? 12 : separateTime;
        }

        getTimeslotStatus(start: Date, seconds: number, includeChannelPeriods: boolean = false): string {
            var end = new Date(start.getTime() + seconds * 1000);
            
            var filter = this.getFilter(start, end);
            var color = "empty";
            if (filter.length > 0) {

                var grouped = this.groupBy(filter, 'type');

                var drawPeriods = grouped[PeriodType.Draw];
                if (drawPeriods != undefined && drawPeriods.length > 0) {
                    $.each(drawPeriods, (index, period) => {
                        var tempColor = "drawperiod";
                        //tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                }

                var bookings = grouped[PeriodType.Wish];
                if (bookings != undefined && bookings.length > 0) {

                    var tempColor = "booking";
                    if (bookings.length > this.minBookingborder && bookings.length <= this.mediumBookingborder) {
                        tempColor += "medium";
                    } else if (bookings.length > this.mediumBookingborder) {
                        tempColor += "hard";
                    }
                    color = this.AddColor(color, tempColor);
                }

                var reservations = grouped[PeriodType.Booking];
                if (reservations != undefined && reservations.length > 0) {
                    $.each(reservations, (index, period) => {
                        var tempColor = "reservation";
                        if (period.userId == this.currentUsersId) {
                            tempColor = "reservationbyme";
                        }
                        //tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) reservation(?!\-start|\-end)/g, 'drawperiod reservation');
                }

                var availabilityLocks = grouped[PeriodType.AvailabilityLock];
                if (availabilityLocks != undefined && availabilityLocks.length > 0) {
                    $.each(availabilityLocks, (index, period) => {
                        var tempColor = "availabilitylock";
                        //tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) availabilitylock(?!\-start|\-end)/g, 'drawperiod availabilitylock');
                }

                var relationshipMatrix = grouped[PeriodType.RelationshipMatrixLock];
                if (relationshipMatrix != undefined && relationshipMatrix.length > 0) {
                    if (reservations == undefined || reservations.length == 0 || color.indexOf("-start") > 0 || color.indexOf("-end") > 0) {
                        $.each(relationshipMatrix, (index, period) => {
                            var tempColor = "reservation";
                            //tempColor += this.getStatus(period, dayToTest);
                            color = this.AddColor(color, tempColor);
                        });
                        color = color.replace(/drawperiod(\-start|\-end) reservation(?!\-start|\-end)/g, 'drawperiod reservation');
                    }
                }

                var lockedPeriods = grouped[PeriodType.Locked];
                if (lockedPeriods != undefined) {
                    $.each(lockedPeriods, (index, period) => {
                        var tempColor = "locked";
                        //tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) locked(?!\-start|\-end)/g, 'drawperiod locked');
                }

                var restricted = grouped[PeriodType.Restricted];
                if (!includeChannelPeriods && restricted != undefined && restricted.length > 0) {
                    $.each(restricted, (index, period) => {
                        if (!period.tilladBrugerAtSeBookingerIPerioden) {
                            color = "restrictedPeriod";
                        }
                        else {
                            color += " restrictedPeriod";
                        }
                    });
                }

                var channelPeriods = grouped[PeriodType.Channel];
                if (channelPeriods && channelPeriods.length > 0 && includeChannelPeriods && (!restricted || restricted.length == 0)) {
                    color = color.replace("restrictedPeriod", "");
                }
            }

            if (this.showPeriodseperation && (color.indexOf("-start") > -1 || color.indexOf("-end") > -1)) {
                color += " bookingSeparator";
            }

            return color;
        }

        timeslotHasPrice(start: Date, seconds: number) {
            var end = new Date(start.getTime() + seconds * 1000);
            var filter = this.getFilter(start, end);
            return !(filter.length > 0 && filter[0].type === PeriodType.PriceMissing);
        }

        private getTitleFromType(type: PeriodType) {
            switch (type) {
                case PeriodType.Wish:
                    return 'Ønske';
                case PeriodType.Booking:
                    return 'Booking';
                case PeriodType.Locked:
                    return 'Låst';
                default:
                    return '';
            }
        }

        async getTitleForDay(selectedDate: Date) {
            var filter = this.getFilter(selectedDate, selectedDate) || [];
            var title = '';
            var bookings = filter.filter((booking) => booking.userId > 0 || booking.type == PeriodType.RelationshipMatrixLock || booking.type == PeriodType.AvailabilityLock);
            for (var booking of bookings) {
                if (booking.type == PeriodType.RelationshipMatrixLock && booking.relationship) {
                    title += `Låst til ${booking.relationship}\n`;
                    continue;
                }

                if (booking.type == PeriodType.AvailabilityLock && booking.relationship) {
                    title += `${booking.bookingId}: ${booking.relationship}\n`;
                    continue;
                }

                if (booking.userFullname && booking.userFullname.length > 0) {
                    title += `${this.getTitleFromType(booking.type)} ${booking.id} - ${booking.userFullname} \n`;
                    continue;
                }

                var result = await this.getUserFullname(booking.userId);
                booking.userFullname = result;
                title += `${this.getTitleFromType(booking.type)} ${booking.id} - ${booking.userFullname}\n`;
            }
            return title;
        }

        getUserFullname(userId: number): Promise<string> {
            return new Promise((resolve, reject) => {
                if (userId <= 0) {
                    reject('');
                    return;
                }

                $.getJSON(`/api/user/userfullname`, { userId: userId }, (result) => {
                    resolve(result);
                });
            });
        }

        getBookinginfoForDay(dayToTest: Date): string {
            var result = "";
            var filter = this.getFilter(dayToTest, dayToTest);
            for (var c = 0; c < filter.length; c++) {
                var booking = filter[c];
                if (booking.type == PeriodType.RelationshipMatrixLock && booking.relationship != null && booking.relationship != undefined && booking.relationship.length > 0) {
                    result += `Låst til ${booking.relationship}\n`;
                }
                else if (booking.type == PeriodType.AvailabilityLock) {
                    result += `${booking.bookingId}: ${booking.relationship}\n`;
                }
                else if (booking.userFullname !== null && booking.userFullname.length > 0) {
                    result += `${booking.id}: ${booking.userFullname}\n`;
                }
            }
            return result;
        }

        dayHasPrice(dayToTest: Date): boolean {
            var filter = this.getFilterWithoutTime(dayToTest);
            return !(filter.length > 0 && filter[0].type === PeriodType.PriceMissing);
        }

        getEventstatusForDay(dayToTest: Date): string {
            var color = "";
            var filter = this.getFilter(dayToTest, dayToTest);
            if (filter.length > 0) {
                var grouped = this.groupBy(filter, 'type');

                var events = grouped[PeriodType.Event];
                if (events != undefined && events.length > 0) {
                    $.each(events, (index, period) => {
                        var tempColor = "event";
                        tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) locked(?!\-start|\-end)/g, 'drawperiod locked');
                }
            }

            return color;
        }

        getStatusForDay(dayToTest: Date, includeChannelPeriods: boolean = false): string {
            
            var filter = this.getFilterWithoutTime(dayToTest);
            //var filter = this.getFilter(dayToTest, dayToTest);
            var color = "empty";
            if (includeChannelPeriods) {
                color += " restrictedPeriod"
            }

            if (filter.length > 0) {

                var grouped = this.groupBy(filter, 'type');

                var drawPeriods = grouped[PeriodType.Draw]
                if (drawPeriods != undefined && drawPeriods.length > 0) {                    
                    $.each(drawPeriods, (index, period) => {
                        var tempColor = "drawperiod";
                        tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                }

                var bookings = grouped[PeriodType.Wish];
                if (bookings != undefined && bookings.length > 0) {

                    var tempColor = "booking";
                    if (bookings.length > this.minBookingborder && bookings.length <= this.mediumBookingborder) {
                        tempColor += "medium";
                    } else if (bookings.length > this.mediumBookingborder) {
                        tempColor += "hard";
                    }
                    color = this.AddColor(color, tempColor);
                }

                var reservations = grouped[PeriodType.Booking];
                if (reservations != undefined && reservations.length > 0) {      
                    $.each(reservations, (index, period) => {
                        var tempColor = "reservation";
                        if (period.userId == this.currentUsersId) {
                            tempColor = "reservationbyme";
                        }

                        tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) reservation(?!\-start|\-end)/g, 'drawperiod reservation');
                    color = color.replace(/(drawperiod(?!\-start|\-end).*?reservation)-(?:start|end)/g, '$1');
                }

                var availabilityLocks = grouped[PeriodType.AvailabilityLock];
                if (availabilityLocks != undefined && availabilityLocks.length > 0) {
                    $.each(availabilityLocks, (index, period) => {
                        var tempColor = "availabilitylock";
                        tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) availabilitylock(?!\-start|\-end)/g, 'drawperiod availabilitylock');
                }

                var relationshipMatrix = grouped[PeriodType.RelationshipMatrixLock];
                if (relationshipMatrix != undefined && relationshipMatrix.length > 0) {
                    if (reservations == undefined || reservations.length == 0 || color.indexOf("-start") > 0 || color.indexOf("-end") > 0) {
                        $.each(relationshipMatrix, (index, period) => {
                            var tempColor = "reservation";
                            tempColor += this.getStatus(period, dayToTest);
                            color = this.AddColor(color, tempColor);
                        });
                        color = color.replace(/drawperiod(\-start|\-end) reservation(?!\-start|\-end)/g, 'drawperiod reservation');
                    }
                }

                var lockedPeriods = grouped[PeriodType.Locked];
                if (lockedPeriods != undefined) {
                    $.each(lockedPeriods, (index, period) => {
                        var tempColor = "locked";
                        tempColor += this.getStatus(period, dayToTest);
                        color = this.AddColor(color, tempColor);
                    });
                    color = color.replace(/drawperiod(\-start|\-end) locked(?!\-start|\-end)/g, 'drawperiod locked');
                }

                var restricted = grouped[PeriodType.Restricted];
                if (!includeChannelPeriods && restricted != undefined && restricted.length > 0) {
                    $.each(restricted, (index, period) => {
                        if (!period.tilladBrugerAtSeBookingerIPerioden) {
                            color = "restrictedPeriod";
                        }
                        else {
                            color += " restrictedPeriod";
                        }
                    });
                }

                var channelPeriods = grouped[PeriodType.Channel];
                if (channelPeriods && channelPeriods.length > 0 && includeChannelPeriods && (!restricted || restricted.length == 0)) {
                    color = color.replace("restrictedPeriod", "");
                }
            }
            
            if (this.showPeriodseperation && (color.indexOf("-start") > -1 || color.indexOf("-end") > -1)) {
                color += " bookingSeparator";
            }

            return color;
        }

        getFilterForDay(dayToTest: Date): IBooking[] {
            var filter = this.getFilterWithoutTime(dayToTest);
            if (filter.length == 0) {
                return [];
            }
            var grouped = this.groupBy(filter, 'type');
            var bookings = grouped[1];
            if (bookings == undefined) {
                return [];
            }
            return bookings;
        }

        getEventsForDay(dayToTest: Date): IBooking[] {
            var filter = this.getFilterWithoutTime(dayToTest);
            if (filter.length == 0) {
                return [];
            }
            var grouped = this.groupBy(filter, 'type');
            var bookings = grouped[PeriodType.Event];
            if (bookings == undefined) {
                return [];
            }
            return bookings;
        }

        loadDataAjax(houseId: number, startdate: Date, enddate: Date, domain: string = ""): JQueryXHR {
            var self = this;
            //var xhr = $.getJSON(domain + '/api/overview/GetReservationsForHouse?houseId=' + houseId + '&startdate=' + startdate.formatDate("yy-mm-dd") + '&enddate=' + enddate.formatDate("yy-mm-dd"), function (bookings: IBooking[]) {
            var xhr = $.getJSON(domain + '/api/calendar?houseId=' + houseId + '&startdate=' + startdate.formatDate("yy-mm-dd") + '&enddate=' + enddate.formatDate("yy-mm-dd") + '&type=2', function (bookings: IBooking[]) {
                var lockdates: IBooking = bookings.pop();
                self.mindate = self.parseDate(lockdates.arrivaldateRfc1123).getDateWithoutTime();
                self.houseOpenUntill = self.parseDate(lockdates.departuredateRfc1123).getDateWithoutTime();
                self.sysMaxDateGælderIkkeForLodtrækninger = lockdates.sysMaxDateGælderIkkeForLodtrækninger;
                self.bookings = bookings;
                self.houseId = houseId;
            });
            xhr.fail(function () {
                self.bookings = [];
                self.houseId = houseId;
            });
            return xhr;
        }

        getBookingPossibilities(houseId: number, startdate: Date, enddate: Date): Promise<Bookhus.Widgets.IBookingPossibility[]> {
            return new Promise((resolve, reject) => {

                var ajaxCall = $.getJSON('/api/booking/getbookingposibilities', {
                    houseId: houseId,
                    startdate: startdate.formatDate("yy-mm-dd"),
                    enddate: enddate.formatDate("yy-mm-dd")
                });

                ajaxCall.then((possibilities: Bookhus.Widgets.IBookingPossibility[]) => {
                    if (possibilities == undefined || possibilities == null) {
                        possibilities = [];
                    }
                    resolve(possibilities);
                });

                ajaxCall.fail(() => {
                    reject("data not loaded");
                });

            });
        }

        //Når denne er blevet kaldt, vil getDayStatus muligvis opfører sig mærkeligt...
        getBookings(): IBooking[] {
            var self = this;
            var result = [];
            for (var i = 0; i < self.bookings.length; i++) {
                var current = self.bookings[i];
                if (current.type == PeriodType.Booking || current.type == PeriodType.Locked || current.type == PeriodType.Restricted) {

                    current.parsedStartdate = self.parseDate(current.arrivaldateRfc1123);
                    current.parsedEnddate = self.parseDate(current.departuredateRfc1123);
                    result.push(current);
                }
            }
            return result;
        }

        getLoadedEvents(): IBooking[] {
            var grouped = this.groupBy(this.bookings, 'type');
            var bookings = grouped[PeriodType.Event];
            if (bookings == undefined) {
                return [];
            }
            return bookings;
        }

        getChannelPeriodsInRange(startdate: Date, enddate: Date): IBooking[] {
            var self = this;
            var filter = $.grep(this.bookings, function (n: IBooking) {
                if (n.arrivaldateRfc1123 != undefined && n.departuredateRfc1123 != undefined) {
                    n.parsedStartdate = self.parseDate(n.arrivaldateRfc1123).getDateWithoutTime();
                    n.parsedEnddate = self.parseDate(n.departuredateRfc1123).getDateWithoutTime();
                }

                return !((n.parsedEnddate < startdate) || (n.parsedStartdate > enddate)) && n.type == PeriodType.Channel;
            });
            return filter;
        }

        private groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        private AddColor(original, value) {
            if (this.calendarStatusDisplayMode == CalendarStatusDisplayMode.TipOnly && this.checkForStart(value)) {
                return original + " " + value.replace('-start', '');
            }

            if (this.calendarStatusDisplayMode == CalendarStatusDisplayMode.TipOnly && this.checkForEnd(value)) {
                return original;
            }

            if (this.calendarStatusDisplayMode == CalendarStatusDisplayMode.FullRange) {
                return original + " " + value.replace(/-(start|end)$/, '');
            }

            // Hvis der er en drawperiod (uden -start eller -end), så erstat reservation(-start|end) med reservation

            var bookingType = value.indexOf("booking") > -1;
            if (original.indexOf("drawperiod-start") > -1 && bookingType) {
                original += " " + value + "-start";
            }
            else if (original.indexOf("drawperiod-end") > -1 && bookingType) {
                original += " " + value + "-end";
            }            
            else if (this.checkForStart(original)) {
                if (!this.checkForEnd(value) && bookingType) {
                    value += "-end";
                }                
                original += " " + value;
            }
            else if (this.checkForEnd(original)) {
                if (!this.checkForStart(value) && bookingType) {
                    value += "-start";
                }
                original += " " + value;
            }
            else if (original == "drawperiod") {
                original += " " + value;
            }
            else {
                original += " " + value;
            }

            return original;
        }

        private checkForStart(value) {
            return value.indexOf("-start") > -1;
        }

        private checkForEnd(value) {
            return value.indexOf("-end") > -1
        }

        private getStatus(filter, dayToTest) {
            var self = this;
            //Vi kommer til at ændre lidt på tiden, derfor tager vi en kopi
            var tempDateToTest = new Date(dayToTest.getTime());

            var parsedStartTime = this.parseDate(filter.arrivaldateRfc1123);
            var parsedEndTime = this.parseDate(filter.departuredateRfc1123);

            var startTime = parsedStartTime.getDateWithoutTime().getTime();
            var endTime = parsedEndTime.getDateWithoutTime().getTime();

            if (startTime !== endTime) {
                if (startTime === tempDateToTest.getTime()) {
                    return "-start";
                } else if (endTime === tempDateToTest.getTime()) {
                    return "-end";
                }
                return "";
            }            
            
            //TODO: Overvej om vi skal implementere en dag start kl, dag slut kl og en minimum periode krævet for mulig booking

            //start og slut er samme dag, tjek hvor tiderne ligger på dagen
            //Der bookinger hvor tiderne ligger tidligt på dagen vil få -end, omvendt for -start
            startTime = parsedStartTime.getTime();
            endTime = parsedEndTime.getTime();
            if (startTime >= tempDateToTest.setHours(0) && endTime < tempDateToTest.setHours(self.separateTime)) {
                return "-end";
            } else if (startTime >= tempDateToTest.setHours(self.separateTime) && endTime < tempDateToTest.setHours(24)) {
                return "-start";
            }
            
            return "";
        }

        private getFilterWithoutTime(dayToTest: Date): IBooking[] {
            var self = this;
            var filter = $.grep(this.bookings, function (n: IBooking) {
                if (n.arrivaldateRfc1123 != undefined && n.departuredateRfc1123 != undefined) {
                    n.parsedStartdate = self.parseDate(n.arrivaldateRfc1123);
                    n.parsedEnddate = self.parseDate(n.departuredateRfc1123);
                }
                
                return n.parsedStartdate.getDateWithoutTime() <= dayToTest.getDateWithoutTime() && n.parsedEnddate.getDateWithoutTime() >= dayToTest.getDateWithoutTime();
            });
            return filter;
        }

        private getFilter(periodToTestStart: Date, periodToTestEnd: Date): IBooking[] {
            var self = this;
            var filter = $.grep(this.bookings, function (n: IBooking) {
                if (n.arrivaldateRfc1123 != undefined && n.departuredateRfc1123 != undefined) {
                    n.parsedStartdate = self.parseDate(n.arrivaldateRfc1123);
                    n.parsedEnddate = self.parseDate(n.departuredateRfc1123);
                }
                //return n.parsedStartdate <= periodToTestEnd && n.parsedEnddate >= periodToTestStart;
                //(not((booking.EndDate < @startdate) or(booking.StartDate > @enddate)))

                //return (!((n.parsedEnddate <= periodToTestStart) || (n.parsedStartdate >= periodToTestEnd)));
                return (!((n.parsedEnddate <= periodToTestStart) || (n.parsedStartdate >= periodToTestEnd)));
            });
            return filter;
        }

        private parseDate(dateStr: string): Date {
            return new Date(dateStr);
            // tester lige om det virker bedre sådan her..
            // hvis kalenderne ikke virker, så sæt disse linier ind igen...
            //var str = dateStr.split("T");
            //var date = str[0].split("-");
            //var time = str[1].split(":");
            
            //var myDate = new Date(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]), parseInt(time[0]), parseInt(time[1]), parseInt(time[2]), 0);
            //return myDate;
        }

        // private countTypesInArray(array, value) {
        //     var cnt = 0;
        //     for (var i = 0; i < array.length; i++) {
        //         if (array[i].type === value) {
        //             cnt++;
        //         }
        //     }
        //     return cnt;
        // }

        // private getFirstWithSpecificType(array, type) {
        //     for (var i = 0; i < array.length; i++) {
        //         if (array[i].type === type) {
        //             return array[i];
        //         }
        //     }
        //     return null;
        // }

        // private getAllWithSpecificType(array, type) {
        //     var temp = [];
        //     for (var i = 0; i < array.length; i++) {
        //         if (array[i].type === type) {
        //             temp.push(array[i]);
        //         }
        //     }
        //     return temp;
        // }

        // private isAllTypesInArray(array, value, ignoreValue) {
        //     for (var i = 0; i < array.length; i++) {
        //         if ((array[i].type !== value) &&
        //             array[i].type !== ignoreValue &&
        //             array[i].type !== -5 &&
        //             array[i].type !== -6
        //         ) {
        //             return false;
        //         }
        //     }
        //     return true;
        // }

        // private sortArray(array:IBooking[]):IBooking[] {
        //     if (new Date(array[0].enddate).getDateWithoutTime().getTime() === new Date(array[1].startdate).getDateWithoutTime().getTime()) {
        //         return array;
        //     }
        //     var list: Array<IBooking> = [array[1], array[0]];
        //     return list;
        // }
    }
}